import {getLocation, hasNavigableProtocol} from 'common/util/url';

import {UrlManager} from './types';

export class WindowUrlManager implements UrlManager {
  getPath() {
    return getLocation().pathname;
  }

  getHash() {
    return getLocation().hash;
  }

  getQueryStringParam(paramName: string) {
    let paramVal = new URLSearchParams(getLocation().search).get(paramName);
    if (paramVal === null) {
      paramVal = new URLSearchParams(getLocation().hash).get(paramName); // wtf dashboards
    }
    return paramVal;
  }

  getLocation() {
    return getLocation();
  }

  setLocation(url: string) {
    if (!hasNavigableProtocol(url)) {
      throw new Error(`Refusing to navigate to a URL with an unsafe protocol`);
    }
    window.location.assign(url);
  }

  openInNewTab(url: string | URL, target?: string, features?: string) {
    if (!hasNavigableProtocol(url)) {
      throw new Error(`Refusing to open a URL with an unsafe protocol`);
    }
    window.open(url, target, features);
  }

  historyReplaceState(data: any, unused: string, url: string | URL) {
    window.history.replaceState(data, unused, url);
  }

  historyPushState(data: any, unused: string, url: string | URL) {
    window.history.pushState(data, unused, url);
  }
}
